// CaryPact VIP levels — from the current compensation-plan infographic
// ("Level / Personal Performance / Leg Effective Performance / VIP Base Weight").
// A level requires BOTH Personal Performance (USDT mining) AND Leg Effective Performance.
export const VIP_THRESHOLDS = [
  { level: 1, personal: 500, leg: 10_000, weight: 1 },
  { level: 2, personal: 1_000, leg: 30_000, weight: 2.2 },
  { level: 3, personal: 1_500, leg: 80_000, weight: 4.8 },
  { level: 4, personal: 2_000, leg: 200_000, weight: 10.6 },
  { level: 5, personal: 3_000, leg: 500_000, weight: 23 },
  { level: 6, personal: 4_000, leg: 1_600_000, weight: 51 },
  { level: 7, personal: 5_000, leg: 5_000_000, weight: 113 },
  { level: 8, personal: 10_000, leg: 12_000_000, weight: 170 },
  { level: 9, personal: 15_000, leg: 30_000_000, weight: 255 },
  { level: 10, personal: 20_000, leg: 100_000_000, weight: 383 },
];

export function vipInfo(cpData) {
  const personal = Number(cpData?.totalLockUsdtAmount || 0);
  const leg = Number(cpData?.smallAreaValue || 0);
  let level = 0;
  for (const t of VIP_THRESHOLDS) {
    if (personal >= t.personal && leg >= t.leg) level = t.level;
  }
  const nextT = VIP_THRESHOLDS.find((t) => t.level === level + 1);
  const next = nextT
    ? {
        level: nextT.level,
        reqPersonal: nextT.personal,
        reqLeg: nextT.leg,
        needPersonal: Math.max(0, nextT.personal - personal),
        needLeg: Math.max(0, nextT.leg - leg),
      }
    : null;
  return { level, personal, leg, next };
}

export const fmtUsdShort = (n) => {
  n = Number(n || 0);
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(n >= 10_000_000 ? 0 : 1)}M`;
  if (n >= 1_000) return `$${(n / 1_000).toFixed(n >= 10_000 ? 0 : 1)}k`;
  return `$${Math.round(n)}`;
};
